import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const NewOrderPage = loadable(() => withDefaultLoaderModifiers(import("./NewOrderPage")));
